import { CircleImage, CircleImageProps } from '../../../components/CircleImage';
import { Loading } from '../../../components/Loading';
import UI from '../../../domains/UI';
import { useProductIconQuery } from '../../graphql';

export type IconProps = {
	id: string;
	name: string;
	circleImageProps?: Partial<CircleImageProps>;
};

export const Icon: React.FC<IconProps> = ({ id, name, circleImageProps }) => {
	const { data, error } = useProductIconQuery({
		variables: { productId: id }
	});
	UI.actions.useApolloError(error);

	if (!data) return <Loading />;

	if (!data.product) return null;

	return (
		<CircleImage
			alt={`${name} icon.`}
			className="product-icon"
			label=""
			onClick={console.log}
			url={data.product.icon}
			size="tiny"
			{...circleImageProps}
		/>
	);
};
